module.exports = __webpack_public_path__ + "static/media/datasheet_musicData_row0_havefun.8494d77e.png";